import {Component, OnInit} from '@angular/core';
@Component ({
	selector: 'amd-version',
	templateUrl: './version.component.html',
	styleUrls: ['./version.component.scss']
})
export class VersionComponent implements OnInit {
	version: string = require('../../../../../package.json').version;

	constructor() {
	}

	ngOnInit(): void {

	}

}
